module.exports = __webpack_public_path__ + "313f4b6ff8689c1a8e746df6161deb6a.ttf";